import React, { useContext } from "react";
import { useDropzone } from "react-dropzone";
import { ThemeContext } from "../context/themeContext";

const FileUpload = ({
  setUploadedFiles,
  uploadedFiles,
  setErrorMessage,
  errorMessage,
}) => {
  const { theme } = useContext(ThemeContext);

  const customStyles = {
    boxShadow: "0px 0px 5px 0px #0000001A",
  };

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: { "text/csv": [".csv"] },
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (!file) return;

      if (file.type !== "text/csv") {
        setErrorMessage(
          `${file.name}: Ungültiges Dateiformat. Nur CSV-Dateien sind erlaubt.`
        );
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        setErrorMessage(
          `${file.name}: Datei ist zu groß. Maximal erlaubte Größe ist 10 MB.`
        );
        return;
      }

      setErrorMessage("");
      setUploadedFiles([file]);
    },
  });

  return (
    <div
      {...getRootProps()}
      className="w-full cursor-pointer"
    >
      <input {...getInputProps()} />
      <div
        className="shadow-md drop-shadow-md min-h-10 dark:bg-asian-filter-dark border-[1px] border-[#f2f2f2] 
        dark:border-none text-center rounded mt-4 flex justify-center items-center"
        style={customStyles}
      >
        <div className="text-center pt-20 pb-20">
          <img
            src={
              theme === "dark"
                ? "/static/upload-icon2.svg"
                : "/static/upload-icon1.svg"
            }
            width={30}
            className="m-auto"
            alt="uploadicon"
          />
          <div className="mt-4 flex text-sm text-uploadText justify-center items-center mb-2">
            <label
              htmlFor="file-upload"
              className="relative focus-within:outline-none text-center"
            >
              <span>Datei ablegen oder klicken</span>
            </label>
          </div>
          <p className="text-xs text-uploadText text-center max-w-[220px]">
            Erlaubtes Format: *.csv bis zu 10 MB
          </p>
          {errorMessage && (
            <p className="text-xs text-red-500 text-center max-w-[220px] mt-3">
              {errorMessage}
            </p>
          )}
        </div>
      </div>
      <ul>
        {uploadedFiles.map((file) => (
          <li className="text-textTitle mt-2" key={file.name}>
            {file.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FileUpload;
